import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import ServicesReceived4 from "../Forms/K/ServicesReceived/ServicesReceived4"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const ServicesReceived4Container = ({
  showToolBar,
  disabled,
  interview_id,
}) => {
  const { interview, handleSubmitGet, handleLoadPrev, loadCollection } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)
  const [isGettingServicesReceived, setIsGettingServicesReceived] =
    useState(true)

  const toast = useRef()

  useEffect(() => {
    setIsGettingServicesReceived(true)
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      handleSubmitGet(endpoints.GET_SERVICESRECEIVED_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_4,
      })
        .then((response) => {
          loadCollection(
            setValues(response.data),
            INTERVIEW_SECTIONS.SERVICES_RECEIVED_4
          )
          handleLoadPrev(false)
          setIsGettingServicesReceived(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingServicesReceived(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_k_es_1: data?.form?.gpraKEs1 ?? 0,
      gpra_k_es_2: data?.form?.gpraKEs2 ?? 0,
      gpra_k_es_3: data?.form?.gpraKEs3 ?? 0,
      gpra_k_es_4: data?.form?.gpraKEs4 ?? 0,
      gpra_k_es_5: data?.form?.gpraKEs5 ?? 0,
      gpra_k_es_6: data?.form?.gpraKEs6 ?? 0,
      gpra_k_es_7: data?.form?.gpraKEs7 ?? 0,
      gpra_k_es_7a: data?.form?.gpraKEs7a ?? "",
      gpra_k_ptp_1: data?.form?.gpraKPtp1 ?? 0,
      gpra_k_ptp_2: data?.form?.gpraKPtp2 ?? 0,
      gpra_k_ptp_3: data?.form?.gpraKPtp3 ?? 0,
      gpra_k_ptp_4: data?.form?.gpraKPtp4 ?? 0,
      gpra_k_ptp_5: data?.form?.gpraKPtp5 ?? 0,
      gpra_k_ptp_6: data?.form?.gpraKPtp6 ?? 0,
      gpra_k_ptp_7: data?.form?.gpraKPtp7 ?? 0,
      gpra_k_ptp_8: data?.form?.gpraKPtp8 ?? 0,
      gpra_k_ptp_8a: data?.form?.gpraKPtp8a ?? "",
      gpra_k_ptp_9: data?.form?.gpraKPtp9 ?? 0,
      gpra_k_ptp_9a: data?.form?.gpraKPtp9a ?? "",
      gpra_k_id: data?.form?.gpraKId ?? "",
      additional: data?.additional,
    }
  }
  if (isGettingServicesReceived) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingServicesReceived && (
        <ServicesReceived4 showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default ServicesReceived4Container
